export default __webpack_public_path__ + "static/media/sample reading.c3950b42.PNG";